<template>
    <div class="download">
        <!-- 头部 -->
        <zmlmenupage cn-name='应用详情' en-name='applicationDetails Center'></zmlmenupage>
        <!-- 内容 -->
        <div class="download-container">
            <div class="detail-con">
                <div class="product-hero">
                    <div class="product-hero__media">
                        <img :src="currentDetail.icon" alt="">
                    </div>
                    <div class="product-hero__p">
                        <p>{{currentDetail.detailName}}</p>
                    </div>
                </div>
                <div class="section--bordered"></div>
                <div class="product-content">
                    <h2>截屏</h2>
                    <div class="product-img">
                        <div class="screenshots-list">
                            <img v-for="(item) in 4" :key="item" :src="`../../static/img/down/${currentDetail.productImg}_${item}.png`" alt="">
                        </div>
                    </div>
                    <div class="section--bordered"></div>
                    <div>
                        <p>{{currentDetail.content}}</p>
                    </div>
                    <div class="section--bordered"></div>
                    <h3 class="download-tit">{{currentDetail.type == 'mercnahtCode' ? '扫码试用' : '扫码下载'}}</h3>
                    <div class="code">
                        <img v-if="currentDetail.type == 'mercnahtCode'" :src="currentDetail.codeImg" alt="">
                        <div style="display: inline-block" v-else></div>
                        <canvas style="display:none" id="merQRCode"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from "qrcode";
export default {
    name: 'downloadetail',

    data() {
        return {
            detailList: [
                {
                    type: 'merchantIos',
                    icon: '../../static/img/app_share_ship_merchant-app-logo.png',
                    detailName: '货运江湖船运货主版iOS端',
                    content: '找货、找船，就找货运江湖！货运江湖平台是广东货多多物流科技有限公司旗下产品，为货主船东提供水路运输的相关资讯，并可通过平台找到海量的货源信息和船舶信息，为货主的运输保驾护航，为船东降低空载提高收入。【功能特色】货主快速发货，智能匹配船舶信息，货物运输省时省力；船东快速注册，一键接单，运费秒到。',
                    productImg: 'ship_m_io',
                    href: 'https://itunes.apple.com/cn/app//id1453395601?mt=8',
                },
                {
                    type: 'mercnahtAndroid',
                    icon: '../../static/img/app_share_ship_merchant-app-logo.png',
                    detailName: '货运江湖水运货主版Android端',
                    content: '找货、找船，就找货运江湖！货运江湖平台是广东货多多物流科技有限公司旗下产品，为货主船东提供水路运输的相关资讯，并可通过平台找到海量的货源信息和船舶信息，为货主的运输保驾护航，为船东降低空载提高收入。【功能特色】货主快速发货，智能匹配船舶信息，货物运输省时省力；船东快速注册，一键接单，运费秒到。',
                    productImg: 'ship_m_an',
                    href: 'https://m.pp.cn/detail.html?appid=7955901&ch_src=pp_dev&ch=default',
                },
                {
                    type: 'shipperIos',
                    icon: '../../static/img/app_share_shipper-app-logo.png',
                    detailName: '货运江湖船东版iOS端',
                    content: '找货、找船，就找货运江湖！货运江湖平台是广东货多多物流科技有限公司旗下产品，为货主船东提供水路运输的相关资讯，并可通过平台找到海量的货源信息和船舶信息，为货主的运输保驾护航，为船东降低空载提高收入。【功能特色】货主快速发货，智能匹配船舶信息，货物运输省时省力；船东快速注册，一键接单，运费秒到。',
                    productImg: 'shipperIos',
                    href: 'https://itunes.apple.com/cn/app//id1453406597?mt=8',
                },
                {
                    type: 'shipperAndroid',
                    icon: '../../static/img/app_share_shipper-app-logo.png',
                    detailName: '货运江湖船东版Android端',
                    content: '找货、找船，就找货运江湖！货运江湖平台是广东货多多物流科技有限公司旗下产品，为货主船东提供水路运输的相关资讯，并可通过平台找到海量的货源信息和船舶信息，为货主的运输保驾护航，为船东降低空载提高收入。【功能特色】货主快速发货，智能匹配船舶信息，货物运输省时省力；船东快速注册，一键接单，运费秒到。',
                    productImg: 'shipperAn',
                    href: 'https://m.pp.cn/detail.html?appid=7955902&ch_src=pp_dev&ch=default',
                },
                {
                    type: 'mercnahtCode',
                    icon: '../../static/img/app_share_shipper-app-logo.png',
                    detailName: '货运江湖船东版小程序',
                    content: '找货、找船，就找货运江湖！货运江湖平台是广东货多多物流科技有限公司旗下产品，为货主船东提供水路运输的相关资讯，并可通过平台找到海量的货源信息和船舶信息，为货主的运输保驾护航，为船东降低空载提高收入。【功能特色】货主快速发货，智能匹配船舶信息，货物运输省时省力；船东快速注册，一键接单，运费秒到。',
                    productImg: 'shipperPr',
                    codeImg: '../../static/img/down/ship_code.png'
                },
                {
                    type: 'qyMerchantIos',
                    icon: '../../static/img/app_share_merchant-app-logo.png',
                    detailName: '货运江湖汽运货主版iOS端',
                    content: '货运江湖货运平台货主端APP，货主可通过平台快速找到经过平台认证的司机，实现货物的安全、快速运输。',
                    productImg: 'qy_m_io',
                    href: 'https://itunes.apple.com/cn/app//id1448082802?mt=8',
                },
                {
                    type: 'qyMerchantIosAndroid',
                    icon: '../../static/img/app_share_merchant-app-logo.png',
                    detailName: '货运江湖汽运货主版Android端',
                    content: '货运江湖货运平台货主端APP，货主可通过平台快速找到经过平台认证的司机，实现货物的安全、快速运输。',
                    productImg: 'qy_m_an',
                    href: 'https://m.pp.cn/detail.html?appid=8064436&ch_src=pp_dev&ch=default',
                },
                {
                    type: 'driverIos',
                    icon: '../../static/img/app_share_driver-app-logo.png',
                    detailName: '货运江湖司机版iOS端',
                    content: '货运江湖货运平台司机端APP，为司机提供货源筛选，在线接单，运费收款等功能。',
                    productImg: 'driverIos',
                    href: 'https://itunes.apple.com/cn/app//id1446271359?mt=8',
                },
                {
                    type: 'driverAndroid',
                    icon: '../../static/img/app_share_driver-app-logo.png',
                    detailName: '货运江湖司机版Android端',
                    content: '货运江湖货运平台司机端APP，为司机提供货源筛选，在线接单，运费收款等功能。',
                    productImg: 'driverAn',
                    href: 'https://m.pp.cn/detail.html?appid=8064437&ch_src=pp_dev&ch=default',
                },
            ],
            currentDetail: {}
        };
    },
    // 通过传过来的参数判断是显示哪个下载详情
    /**
     * type
     * merchantIos 水运货主ios
     * mercnahtAndroid 水运货主Android
     * shipperIos 水运船东ios
     * shipperAndroid 水运船东Android
     * mercnahtCode 水运船东小程序
     * qyMerchantIos 汽运货主ios
     * qyMerchantIosAndroid 汽运货主Android
     * driverIos 汽运司机ios
     * driverAndroid 汽运司机Android
     */
    created () {
        let that = this
        //根据传参获取当前显示的应用详情
        const type = that.$route.params.type
        const obj = that.detailList.find(item => item.type == type)
        that.currentDetail = { ...obj }
        if(obj.type != 'mercnahtCode') {
            setTimeout(function () {
                that.toMakeQRCode(obj.href)
            }, 100)
        }

    },

    methods: {
        //生成二维码
        toMakeQRCode(value) {
            var qrCodeDom = document.getElementById("merQRCode");
            QRCode.toCanvas(
                qrCodeDom,
                value,
                {
                width: 250,
                },
                function (error) {
                    if (error) {
                        console.error("生成二维码失败：", error);
                    } else {
                        //把canvas转换成图片  用于移动端识别
                        const imageData = qrCodeDom.toDataURL("image/png"); // 将Canvas转换为Base64图像数据
                        const imgElement = document.createElement("img");
                        const code = document.querySelector('.code')
                        imgElement.src = imageData;
                        code.appendChild(imgElement);
                     }
                }
            );

         },
    },
};
</script>

<style scoped>
  .download-container {
    padding: 100px 0;
    width: 1400px;
    height: 100%;
    margin: auto;
  }
  .detail-con {
    margin-top: 40px;
    -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    padding: 60px;
   }
  .product-hero__media  {
    width: 120px;
    height: 120px;
    border: 1px solid #f0f0f0;
    border-radius: 10%;
    display: inline-block;
  }
  .product-hero__media > img {
    width: 100%;
    height: 100%;
  }
  .product-hero__p {
   display: inline-block;
    vertical-align: top;
    font-size: 24px;
    padding-left: 30px;
    padding-top: 11px;
  }
  .product-content {
    margin-top: 37px;
  }
  .section--bordered {
    border-top: 1px solid #d6d6d6;
  }
   .product-content > h2 {
        margin-top: 40px;
        margin-bottom: 40px;
        flex-shrink: 1;
        font-size: 20px;
        line-height: 1.2;
        font-weight: 500;
        letter-spacing: .024em;
   }
   .product-img {
    width: 100%;
    overflow: hidden;
    margin-bottom: 40px;
   }
   .product-img  img {
    width: 230px;
    display: inline-block;;
    border: 1px solid #f0f0f0;
    border-radius: 20px;
    margin-right: 40px;
   }
   .product-content p {
     width: 68%;
    max-width: 68%;
    font-weight: normal;
    text-align: justify;
    padding-top: 30px;
    font-size: 14px;
    color: #1d1d1f;
    /*font-family: 'fontRegular'*/
   }
   .download-tit {
    padding-top: 40px;
   }
   .code > img {
    width: 200px;
    margin-top: 20px;
   }
   .section--bordered {
    margin-top: 37px;
}
@media only screen and (max-width: 750px)  {
   .download-container {
      width: 100%;
      padding: 15px 0px;
      box-sizing: border-box;
   }
   .detail-con {
     margin-top: 10px;
     padding: 20px 0px 20px 20px;
   }
   .product-hero__media {
    width: 80px;
    height: 80px;
   }
   .product-hero__p {
    font-size: 16px;
    padding-left: 8px;
    }
    .product-content > h2 {
        margin-top: 25px;
        margin-bottom: 25px;
    }
    .product-img  img {
        width: 157px;
        border-radius: 14px;
        margin-right: 10px;
    }
    .screenshots-list {
        width: auto;
        min-width: 100%;
        white-space: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .product-content {
        margin-top: 20px;
    }
    .section--bordered {
        margin-right: 20px;
    }
    .product-content p {
        width: 100%;
        max-width: 96%;
    }
 }
</style>



// WEBPACK FOOTER //
// src/pages/applicationDetails.vue